// @flow
import styled from "styled-components"

export const AffiliateSelectWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
`

export const PlaceDetailsWrap = styled.div`
    padding: 2rem;
`


// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/AffiliateSelector/styled.js